type Subscription = (() => void) | {unsubscribe: () => void};

type StreamEntry = {fetchId: number; subscription?: Subscription};

const entriesByCache = new WeakMap<object, Map<string, StreamEntry>>();

// streams of one key write into the same cache entry, so only the latest fetch keeps its stream opened
export const trackStreamFetch = (cache: object, cacheKey: string) => {
  let entries = entriesByCache.get(cache);
  if (!entries) {
    entries = new Map();
    entriesByCache.set(cache, entries);
  }

  const entry = entries.get(cacheKey) ?? {fetchId: 0};
  entries.set(cacheKey, entry);
  entry.fetchId += 1;
  const fetchId = entry.fetchId;

  let ownSubscription: Subscription | undefined;
  let isReleased = false;

  return {
    isCurrent: () => entry.fetchId === fetchId,
    replaceSubscription: (subscription: Subscription) => {
      if (entry.subscription) {
        unsubscribe(entry.subscription);
      }
      ownSubscription = subscription;
      entry.subscription = isReleased ? undefined : subscription;
    },
    release: () => {
      isReleased = true;
      if (ownSubscription && entry.subscription === ownSubscription) {
        entry.subscription = undefined;
      }
    },
  };
};

const unsubscribe = (subscription: Subscription) => {
  if (typeof subscription === 'function') {
    subscription();
    return;
  }

  subscription.unsubscribe();
};
